import { useState } from "react";
import { Card, Button, Form, Tabs, Tab, Alert } from "react-bootstrap";
import { MasterDataService } from "../../../../services/masterDataService";
import './masterDataAdd.css';

const MasterDataAdd = () => {
    const [activeTab, setActiveTab] = useState("ug");
    const [value, setValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const resetState = () => {
        setValue("");
        setStateValue("");
        setMessage(null);
        setError(null);
        setFieldErrors({});
    };

    const handleAdd = async () => {
        setError(null);
        setMessage(null);
        setFieldErrors({});

        // Frontend required validation
        if (activeTab === "city") {
            if (!value || !stateValue) {
                setError("City and State are required.");
                return;
            }
        } else {
            if (!value) {
                setError("Field is required.");
                return;
            }
        }

        try {
            if (activeTab === "ug") {
                await MasterDataService.addUgDegree(value);
            } else if (activeTab === "pg") {
                await MasterDataService.addPgDegree(value);
            } else {
                await MasterDataService.addCity(value, stateValue);
            }

            setMessage("Added successfully!");
            resetState();
        } catch (err) {
            if (err.response?.status === 409) {
                setError("Already exists!");
            } else if (err.response?.data?.fieldViolations) {
                setError(err.response.data.message);
                setFieldErrors(err.response.data.fieldViolations);
            } else {
                setError("Something went wrong.");
            }
        }
    };

    return (
        <div className="p-4 master-data-page">
            <h3 className="master-title">Master Data Management</h3>
            <br />
            <div className="master-card-wrapper">
                <Card className="mt-3 p-4 master-card">
                    <Tabs
                        className="master-tabs"
                        activeKey={activeTab}
                        onSelect={(k) => {
                            setActiveTab(k);
                            resetState();
                        }}
                    >
                        <Tab eventKey="ug" title="UG Degree" />
                        <Tab eventKey="pg" title="PG Degree" />
                        <Tab eventKey="city" title="City" />
                    </Tabs>

                    <Form className="mt-3">
                        {/* UG & PG */}
                        {activeTab !== "city" && (
                            <div className="d-flex align-items-start gap-3 city-row">
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        spellCheck='false'
                                        placeholder={`Enter ${activeTab.toUpperCase()} value`}
                                        value={value}
                                        isInvalid={
                                            !!fieldErrors[
                                            activeTab === "ug"
                                                ? "ugDegreeName"
                                                : "pgDegreeName"
                                            ]
                                        }
                                        onChange={(e) => {
                                            setValue(e.target.value);

                                            const fieldKey =
                                                activeTab === "ug" ? "ugDegreeName" : "pgDegreeName";

                                            setFieldErrors((prev) => ({
                                                ...prev,
                                                [fieldKey]: null,
                                            }));
                                        }} />
                                    <Form.Control.Feedback type="invalid">
                                        {
                                            fieldErrors[
                                            activeTab === "ug"
                                                ? "ugDegreeName"
                                                : "pgDegreeName"
                                            ]
                                        }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button type="button" className="city-add-btn" onClick={handleAdd}>
                                    Add
                                </Button>
                            </div>
                        )}

                        {/* CITY */}
                        {activeTab === "city" && (
                            <div className="d-flex align-items-start gap-3 city-row">

                                <Form.Group className="flex-fill">
                                    <Form.Control
                                        type="text"
                                        spellCheck="false"
                                        placeholder="City"
                                        value={value}
                                        isInvalid={!!fieldErrors.city}
                                        onChange={(e) => {
                                            setValue(e.target.value);
                                            setFieldErrors((prev) => ({
                                                ...prev,
                                                city: null,
                                            }));
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.city}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="flex-fill">
                                    <Form.Control
                                        type="text"
                                        spellCheck="false"
                                        placeholder="State"
                                        value={stateValue}
                                        isInvalid={!!fieldErrors.state}
                                        onChange={(e) => {
                                            setStateValue(e.target.value);
                                            setFieldErrors((prev) => ({
                                                ...prev,
                                                state: null,
                                            }));
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {fieldErrors.state}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button
                                    type="button"
                                    variant="primary"
                                    onClick={handleAdd}
                                    className="city-add-btn"
                                >
                                    Add
                                </Button>

                            </div>
                        )}


                    </Form>

                    {message && (
                        <Alert variant="success" className="mt-3">
                            {message}
                        </Alert>
                    )}

                    {error && (
                        <Alert variant="danger" className="mt-3">
                            {error}
                        </Alert>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default MasterDataAdd;